( function () {
	/* eslint-disable max-params */
	'use strict';

	function reportService ( $q, $http, logger, $resource, Session, apiService, ERROR_MSGS, moment, $location, attachPdfService ) {
		var filters;

		function getReportData ( callback ) {
			$http.get( '../fixtures/report/generate-report.json' )
				.success( function ( data ) {
					callback( data );
				} )
				.error( function ( error ) {
					logger.error( JSON.stringify( error ) );
					logger.notifyError( 'An error occurred while trying to display your report data.' );
				} );
		}

		function setFilterData ( filterData ) {
			filters = filterData;
		}

		function getFilterData () {
			return filters;
		}

		function getPrebuiltReports () {
			return apiService.getPrebuiltReports.query().$promise;
		}

		function getReportDetails ( cb ) {
			function getDetails ( report ) {
				return report.path === $location.url();
			}

			function filterReport ( data ) {
				cb( data.filter( getDetails )[ 0 ] );
			}

			apiService.getPrebuiltReports.query().$promise.then( filterReport );
		}

		function getUserReports () {
			var data = {
				'userId' : Session.getCredentials().userId
			};

			return apiService.getUserReports.query( data ).$promise;
		}

		function changeReport ( report ) {
			var dates = [ 'createdAt', 'updatedAt', 'deletedAt', 'lastRun' ];

			dates.map( function ( index ) {
				if ( !report[ index ] ) {
					delete report[ index ];
					return;
				}

				report[ index ] = moment.tz( report[ index ], moment.tz.guess() ).format( 'MM/DD/YY' );
			} );

			return report;
		}

		function setFavorite ( model ) {
			var data = {
				'reportId' : model.id,
				'userId'   : Session.getCredentials().userId
			};

			return apiService.setFavoriteReport.save( data ).$promise;
		}

		function deleteFavorite ( model ) {
			var data = {
				'reportId' : model.id,
				'userId'   : Session.getCredentials().userId
			};

			return apiService.deleteFavorite.delete( data ).$promise;
		}

		function deleteCustomReport ( model ) {
			var data = {
				'reportId' : model.id,
				'userId'   : Session.getCredentials().userId
			};

			return apiService.deleteCustomReport.update( data ).$promise;
		}

		function changeForDisplay ( data ) {
			return ( data || [] ).map( changeReport );
		}

		function updateDateGenerated ( id ) {
			var data = {
				'reportId' : id
			};

			return apiService.updateDateGenerated.update( data ).$promise;
		}

		function callEtlProcess () {
			return apiService.doEtlProcess( Session.getCredentials().userId );
		}

		function lookUpForLastRun ( prebuilt, allReports ) {
			function iteratePrebuilt ( report ) {
				var filteredReport = allReports.filter( function ( item ) {
					return item.id === report.id;
				} );

				report.lastRun = ( filteredReport[ 0 ] || {} ).lastRun;

				return report;
			}

			return prebuilt.map( iteratePrebuilt );
		}

		function filterReports ( report ) {
			return report.isJasper;
		}

		function filterCustom ( data ) {
			return data.filter( filterReports );
		}

		//  Get all hierarchy based, viewable in-progress observations for a user.
		function inProgressObsReports () {
			return apiService.getInProgressObsReports.query().$promise;
		}

		function getObsDetails ( id ) {
			var data = {
				'userId'        : Session.getCredentials().userId,
				'observations'  : 'observations',
				'observationId' : id
			};

			return apiService.obsStatus.get( data ).$promise;
		}

		return {
			'getReportData'        : getReportData,
			'setFilterData'        : setFilterData,
			'getFilterData'        : getFilterData,
			'getUserReports'       : getUserReports,
			'getPrebuiltReports'   : getPrebuiltReports,
			'changeForDisplay'     : changeForDisplay,
			'setFavorite'          : setFavorite,
			'deleteFavorite'       : deleteFavorite,
			'deleteCustomReport'   : deleteCustomReport,
			'updateDateGenerated'  : updateDateGenerated,
			'lookUpForLastRun'     : lookUpForLastRun,
			'filterCustom'         : filterCustom,
			'getReportDetails'     : getReportDetails,
			'getObsDetails'        : getObsDetails,
			'inProgressObsReports' : inProgressObsReports,
			'hasPdfMake'           : attachPdfService.hasPdfMake,
			'callEtlProcess'       : callEtlProcess
		};
	}

	reportService.$inject = [ '$q', '$http', 'logger', '$resource', 'Session', 'apiService', 'ERROR_MSGS', 'moment', '$location', 'attachPdfService' ];

	angular
		.module( 'app.templates' )
		.factory( 'reportService', reportService );
} )();
